module.exports = __webpack_public_path__ + "static/img/NSW-36.177c917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-36.jpg
// module id = ssCR
// module chunks = 0